__turbopack_context__.v({
  "grid": "Distribution-module-scss-module__Ulnv9q__grid",
  "share-wrapper": "Distribution-module-scss-module__Ulnv9q__share-wrapper",
  "wrapper": "Distribution-module-scss-module__Ulnv9q__wrapper",
});
